<template>
  <DropdownMenu class="international">
    <DropdownMenuTrigger>
      <div class="right-menu-item hover-effect flex items-center px-2">
        <Languages class="size-4" />
      </div>
    </DropdownMenuTrigger>
    <DropdownMenuContent>
      <DropdownMenuItem
        :disabled="language === eAllowedLangs.SK"
        @click="handleSetLanguage(eAllowedLangs.SK)"
      >
        Slovensky
      </DropdownMenuItem>
      <DropdownMenuItem
        :disabled="language === eAllowedLangs.EN"
        @click="handleSetLanguage(eAllowedLangs.EN)"
      >
        English
      </DropdownMenuItem>
      <DropdownMenuItem
        :disabled="language === eAllowedLangs.DE"
        @click="handleSetLanguage(eAllowedLangs.DE)"
      >
        Deutsche
      </DropdownMenuItem>
      <DropdownMenuItem
        :disabled="language === eAllowedLangs.CS"
        @click="handleSetLanguage(eAllowedLangs.CS)"
      >
        Česky
      </DropdownMenuItem>
      <DropdownMenuItem
        :disabled="language === eAllowedLangs.KO"
        @click="handleSetLanguage(eAllowedLangs.KO)"
      >
        한국어
      </DropdownMenuItem>
      <DropdownMenuItem
        divided
        :disabled="language === eAllowedLangs.PT"
        @click="handleSetLanguage(eAllowedLangs.PT)"
      >
        Português
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { localize } from '@vee-validate/i18n'
import { Languages } from 'lucide-vue-next'

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import i18n from '@/lang/'
import { useAppStore } from '@/stores/app'
import { type AllowedLang, eAllowedLangs } from '@/types/shared'
// Computed property
const language = computed(() => useAppStore().language)

// Methods
const handleSetLanguage = (lang: AllowedLang) => {
  i18n.global.locale.value = lang
  useAppStore().setLanguage(lang)
  localize(lang)
}
</script>
